import { store, getEmptyData, OrcasStoreData } from '@/store'
import { IFeatureFlags } from '@sennder/senn-node-microfrontend-interfaces'

export const setStoreLanguage = async (language: string) => {
  store.state.data.language = language
}

export const clearState = () => {
  store.state.data = getEmptyData()
}

export const setStoreData = (data: OrcasStoreData) => {
  store.state.data = data
}

/**
 * Updates the shell's store with new feature flags.
 * When all micro-frontends are migrated to use the new feature flag provider, this function and the related legacy flags in the store can be removed. A new, not shared state can be introduced to store flags for the shell logic.
 * @deprecated Currently is used only to maintain backwards compatibility with the old feature flags setup. Prefer using the featureFlag provider for new implementations.
 */
export const setStoreLegacyFlags = (flags: IFeatureFlags) => {
  store.state.data.featureFlags = {
    ...store.state.data.featureFlags,
    ...flags,
  }
}
